<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="page-title">
          <h1>
            Pending Pickup &amp; Deliveries
          </h1>
        </div>
      </div>
      <div class="col-lg-6 text-right">
        <div class="m-t-md">
          <button
            type="button"
            class="btn btn-success"
            data-toggle="modal"
            data-target="#modal-create-runs"
            @click="assignAll = true"
            :disabled="selectedStations.length > 0"
          >
            Assign All
          </button>
          <button
            type="button"
            class="btn btn-success m-l-sm"
            data-toggle="modal"
            data-target="#modal-create-runs"
            @click="assignAll = false"
            :disabled="selectedStations.length === 0"
          >
            Assign Selected
          </button>
          <button
            type="button"
            class="btn btn-default s-l-sm m-l-sm"
            data-toggle="modal"
            data-target="#modal-add-pickup"
          >
            Add Pickup
          </button>
        </div>
      </div>
    </div>
    <!-- /.row -->

    <div class="portlet portlet-default">
      <div class="portlet-heading">
        <div class="portlet-title">
          <h4>Find Request</h4>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="portlet-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group m-b-sm">
              <label class="control-label">Sort By</label>
              <multiselect
                placeholder
                :preselect-first="false"
                :options="orders"
                v-model="selectedOrder"
                track-by="value"
                label="label"
                :show-labels="false"
                :allow-empty="false"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group m-b-sm">
              <label class="control-label">Search</label>
              <input
                type="text"
                class="form-control"
                :value="filters.search"
                @input="updateSearchValue"
              />
            </div>
            <!-- /.form-group -->
          </div>
        </div>
      </div>
    </div>
    <infinite-scroll @load="load" ref="infinite" >
      <template v-slot:loading="{ invisible }">
        <loading-spinner :class="{ invisible: invisible && !searching }"/>
      </template>
      <ul class="list-data has-multi-checkbox no-links">
        <li class="data-heading visible-lg">
          <div class="row">
            <div class="col-md-4 col-lg-1"><p>Zone</p></div>
            <div class="col-md-3 col-lg-1"><p>S Num</p></div>
            <div class="col-md-8 col-lg-6">
              <p>Fire Station</p>
            </div>
            <div class="col-md-4 col-lg-2">
              <p>Entered Date</p>
            </div>
            <div class="col-md-4 col-lg-1">
              <p>Pickup</p>
            </div>
            <div class="col-md-3 col-lg-1">
              <p>Delivery</p>
            </div>
          </div>
          <!-- /.row -->
        </li>

        <li v-for="station in stations" :key="station.id">
          <div class="form-check checkbox checkbox-success">
            <input :id="`checkbox-station-${station.id}`" class="styled" type="checkbox" v-model="selectedStations" :value="station.id" />
            <label :for="`checkbox-station-${station.id}`"></label>
          </div>

          <div class="row">
            <div class="col-xs-6 col-md-4 col-lg-1">
              <p>
                <span class="data-label hidden-lg">Zone</span> {{ station.zone_number }}
              </p>
            </div>
            <div class="col-xs-6 col-md-3 col-lg-1">
              <p>
                <span class="data-label hidden-lg">S Num</span> {{ station.code }}
              </p>
            </div>
            <div class="col-xs-5 col-md-8 col-lg-6">
              <p>
                <span class="data-label hidden-lg">Fire Station</span>
                <font-awesome :icon="['fas', 'truck']" v-if="station.courier_deliveries" /> {{ station.name }}
                <template v-if="station.requested_by">
                  <font-awesome :icon="['fas', 'user']" class="ml-3"/> {{ station.requested_by.name }}
                </template>
              </p>
              <p class="small strong"><font-awesome :icon="['fas', 'link']" v-if="station.linked_station" /> {{ station.linked_station }}</p>
            </div>
            <div class="col-xs-7 col-md-4 col-lg-2">
              <p class="text-truncate">
                <span class="data-label hidden-lg">Entered Date</span>
                {{ station.entered_date | date({ format: "DD/MM/YYYY h:mma", utc: false }) }}
              </p>
            </div>
            <div class="col-xs-5 col-md-4 col-lg-1">
              <p>
                <span class="data-label hidden-lg">Pickup</span>
                {{ station.pickup }}
              </p>
            </div>
            <div class="col-xs-12 col-md-3 col-lg-1">
              <p>
                <span class="data-label hidden-lg">Delivery</span>
                {{ station.delivery }}
              </p>
            </div>
          </div>
          <!-- /.row -->
        </li>
      </ul>
    </infinite-scroll>
    <!-- /.list-data -->

    <assign-stations-modal v-bind="{ stations, selectedStations, assignAll }" @hidden="assignAll = false"/>
    <add-pickup-modal @added="getPendingStations"/>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'
import { appliesFilters } from '@codium/codium-vue'
import AddPickupModal from './AddPickupModal'
import AssignStationsModal from './AssignStationsModal'
import { debounce } from 'lodash'

export default {
  mixins: [appliesFilters],

  components: {
    AssignStationsModal,
    AddPickupModal
  },

  data () {
    return {
      searching: false,
      assignAll: false,
      selectedStations: [],
      filters: {
        order: null,
        search: ''
      }
    }
  },

  watch: {
    async queryParams (params) {
      try {
        // this.searching = true
        await this.getPendingStations({ fresh: true, params: this.queryParams })
        // this.searching = false

        if (this.$refs.infinite) {
          this.$refs.infinite.restart()
        }
      } catch (error) {
        // Likely no more results thrown...
      }
    }
  },

  computed: {

    stations: get('pendingStations/stations'),

    selectedOrder: {
      set (val) {
        this.filters.order = val.value
      },

      get () {
        return this.orders.find(order => order.value === this.filters.order)
      }
    },

    orders () {
      return [
        { value: 'zone_number|asc', label: 'Zone A-Z' },
        { value: 'zone_number|desc', label: 'Zone Z-A' },
        { value: 'code|asc', label: 'S Number A-Z' },
        { value: 'code|desc', label: 'S Number Z-A' },
        { value: 'name|asc', label: 'Fire Station A-Z' },
        { value: 'name|desc', label: 'Fire Station Z-A' },
        { value: 'pickup_request_created_at|asc', label: 'Entered Date Oldest First' },
        { value: 'pickup_request_created_at|desc', label: 'Entered Date Newest First' }
      ]
    }
  },

  async created () {
    await this.getPendingStations({ params: this.queryParams })
  },

  methods: {
    getPendingStations: call('pendingStations/getPendingStations'),

    updateSearchValue: debounce(function (event) {
      this.filters.search = event.target.value
    }, 4000),

    onModalHidden () {
      this.$emit('hidden')
    },

    async load (done) {
      try {
        await this.getPendingStations({ params: this.queryParams })

        done()
      } catch (error) {
        done(true)
      }
    }
  }
}
</script>

<style scoped>
.ml-3 {
  display: inline-block;
  margin-left: 0.3em;
}
</style>
